
/*
  UXS — INTRO MORPH V4
  SOLID LETTERS → LIVING LINES → ALIEN CIRCLE

  Las líneas salen del RELLENO de las letras.
  No convierte el texto en contornos huecos.
  No utiliza partículas ni puntos aislados.

  NO modifica:
  - uxs-visualizer.js
  - uxs-dialogue.js
  - uxs-vocoder.js
  - uxs-questions.js
  - uxs-record-transition.js
*/

(function () {
  "use strict";

  function initialize() {
    const root = document.getElementById("uxs-experience");
    const intro = document.getElementById("uxs-intro");
    const main = document.getElementById("uxs-main");

    if (!root || !intro || !main) return;

    if (root.dataset.introMorphReady === "true") return;
    root.dataset.introMorphReady = "true";

    const C = {
      title: "UNIDOS X EL SONIDO",
      hint: "SUBE EL VOLUMEN PARA UNA MEJOR EXPERIENCIA",

      background: "#050505",
      white: "#ffffff",

      // Duración compatible con la intro actual
      solidUntil: 2100,
      morphEnd: 4100,
      total: 4500,

      // Densidad de líneas que forman el relleno
      lineSpacing: 1.5,

      // Curvatura durante la transformación
      bend: 20
    };

    const clamp = (n, a, b) =>
      Math.max(a, Math.min(b, n));

    const lerp = (a, b, t) =>
      a + (b - a) * t;

    function ease(value) {
      const t = clamp(value, 0, 1);
      return t * t * (3 - 2 * t);
    }

    // ======================================
    // BLOQUEAR INTRO ANTIGUA
    // ======================================

    intro.style.setProperty(
      "display", "none", "important"
    );

    intro.style.setProperty(
      "animation", "none", "important"
    );

    root.classList.add("uxs-morph-enabled");

    // ======================================
    // ESTILOS
    // ======================================

    const oldStyle =
      document.getElementById("uxs-intro-morph-styles");

    if (oldStyle) oldStyle.remove();

    const style = document.createElement("style");
    style.id = "uxs-intro-morph-styles";

    style.textContent = `
      #uxs-experience.uxs-morph-enabled #uxs-intro {
        display: none !important;
        animation: none !important;
      }

      #uxs-experience.uxs-morph-enabled #uxs-main {
        animation: none !important;
        opacity: 0 !important;
        visibility: hidden !important;
      }

      #uxs-experience.uxs-morph-complete #uxs-main {
        opacity: 1 !important;
        visibility: visible !important;
      }

      #uxs-morph-layer {
        position: absolute;
        inset: 0;
        z-index: 90;
        background: #050505;
        overflow: hidden;
        pointer-events: none;
      }

      #uxs-morph-canvas {
        display: block;
        width: 100%;
        height: 100%;
      }

      #uxs-volume-hint {
        position: absolute;
        left: 50%;
        width: min(90vw, 520px);
        transform: translateX(-50%);
        text-align: center;

        color: rgba(255,255,255,.40);
        font-family: monospace;
        font-size: clamp(9px, 1.8vw, 11px);
        font-weight: 400;
        letter-spacing: 1.3px;
        line-height: 1.8;

        opacity: 0;
        pointer-events: none;
      }
    `;

    document.head.appendChild(style);

    // ======================================
    // CAPA VISUAL TEMPORAL
    // ======================================

    const layer = document.createElement("div");
    layer.id = "uxs-morph-layer";
    layer.setAttribute("aria-hidden", "true");

    const canvas = document.createElement("canvas");
    canvas.id = "uxs-morph-canvas";

    const hint = document.createElement("div");
    hint.id = "uxs-volume-hint";
    hint.textContent = C.hint;

    layer.appendChild(canvas);
    layer.appendChild(hint);
    root.appendChild(layer);

    const ctx = canvas.getContext("2d");

    function showRealCircle() {
      root.classList.add("uxs-morph-complete");

      main.style.setProperty(
        "animation", "none", "important"
      );
      main.style.setProperty(
        "opacity", "1", "important"
      );
      main.style.setProperty(
        "visibility", "visible", "important"
      );
    }

    if (!ctx) {
      showRealCircle();
      layer.remove();
      return;
    }

    // ======================================
    // ESTADO
    // ======================================

    let width = 0;
    let height = 0;
    let dpr = 1;

    let fontSize = 40;
    let titleY = 0;
    let titleScale = 1;

    let textCanvas = null;
    let textBounds = null;
    let strokes = [];

    let startedAt = null;
    let raf = null;
    let finished = false;

    // ======================================
    // LOCALIZAR CÍRCULO ORIGINAL
    // ======================================

    function getCircle() {
      const element =
        document.getElementById("uxs-visualizer") ||
        main.querySelector(".uxs-orb");

      if (!element) {
        return {
          x: width / 2,
          y: height / 2,
          radius: 76
        };
      }

      const rect = element.getBoundingClientRect();
      const parent = root.getBoundingClientRect();

      const size = rect.width || 320;

      return {
        x: rect.left - parent.left + size / 2,
        y: rect.top - parent.top + (rect.height || size) / 2,

        // Solo lee la geometría del círculo.
        // NO la modifica.
        radius: size * 76 / 320
      };
    }

    // ======================================
    // TEXTO SÓLIDO ORIGINAL
    // ======================================

    function createTextSource() {
      const off = document.createElement("canvas");

      off.width = 1200;
      off.height = 180;

      const oc = off.getContext("2d", {
        willReadFrequently: true
      });

      if (!oc) return null;

      oc.clearRect(0, 0, off.width, off.height);

      oc.fillStyle = C.white;
      oc.font = "400 64px monospace";
      oc.textAlign = "center";
      oc.textBaseline = "middle";

      const measured = oc.measureText(C.title).width;

      const fit = Math.min(
        1,
        1130 / Math.max(1, measured)
      );

      oc.save();
      oc.translate(600, 90);
      oc.scale(fit, fit);
      oc.fillText(C.title, 0, 0);
      oc.restore();

      return off;
    }

    // ======================================
    // EXTRAER LAS LÍNEAS DEL RELLENO
    // ======================================

    /*
      En vez de extraer solo los bordes,
      leemos todas las filas del texto sólido.

      Cada tramo blanco de una fila se
      convierte en una línea continua.

      Al estar muy juntas, esas líneas
      siguen formando letras sólidas.

      Durante el morph, cada línea se curva
      hacia el círculo manteniendo su trazo.
    */

    function extractFilledLines(offscreen) {
      const oc = offscreen.getContext("2d", {
        willReadFrequently: true
      });

      const sw = offscreen.width;
      const sh = offscreen.height;

      const pixels = oc.getImageData(
        0, 0, sw, sh
      ).data;

      const lines = [];

      for (
        let y = 0;
        y < sh;
        y += C.lineSpacing
      ) {
        const py = Math.floor(y);
        let start = -1;

        for (let x = 0; x <= sw; x++) {
          const alpha =
            x < sw
              ? pixels[(py * sw + x) * 4 + 3]
              : 0;

          const filled = alpha > 75;

          if (filled && start === -1) {
            start = x;
          }

          if (!filled && start !== -1) {
            if (x - start >= 1) {
              lines.push({
                x1: start,
                x2: x,
                y: py
              });
            }

            start = -1;
          }
        }
      }

      return lines;
    }

    // ======================================
    // PREPARAR ESCENA
    // ======================================

    function prepare() {
      const rect = root.getBoundingClientRect();

      width = rect.width || window.innerWidth;
      height = rect.height || window.innerHeight;

      dpr = Math.min(
        window.devicePixelRatio || 1,
        2
      );

      canvas.width = Math.round(width * dpr);
      canvas.height = Math.round(height * dpr);

      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      fontSize = Math.min(
        46,
        Math.max(16, width * 0.054)
      );

      titleY = height / 2 - 14;

      textCanvas = createTextSource();
      if (!textCanvas) return;

      titleScale = fontSize / 64;

      // Ajuste para no salir de pantalla.
      titleScale = Math.min(
        titleScale,
        width * 0.9 / 1140
      );

      const rawLines =
        extractFilledLines(textCanvas);

      const centerX = width / 2;

      strokes = rawLines.map(line => ({
        x1: centerX + (line.x1 - 600) * titleScale,
        x2: centerX + (line.x2 - 600) * titleScale,
        y: titleY + (line.y - 90) * titleScale
      }));

      hint.style.top =
        `${titleY + fontSize * 0.9 + 18}px`;
    }

    // ======================================
    // TÍTULO CON RELLENO COMPLETO
    // ======================================

    function drawSolid() {
      if (!textCanvas) return;

      const dw = textCanvas.width * titleScale;
      const dh = textCanvas.height * titleScale;

      ctx.drawImage(
        textCanvas,
        width / 2 - dw / 2,
        titleY - dh / 2,
        dw,
        dh
      );
    }

    // ======================================
    // LÍNEAS DEL MISMO TEXTO
    // ======================================

    function drawLivingStrokes(progress, now) {
      const t = ease(progress);
      const circle = getCircle();

      ctx.save();

      ctx.strokeStyle = C.white;
      ctx.lineCap = "round";
      ctx.lineJoin = "round";

      // Mantener suficiente densidad
      // para que no se vean puntos aislados.
      ctx.lineWidth = Math.max(
        1,
        titleScale * C.lineSpacing * 1.12
      );

      const count = Math.max(1, strokes.length);

      strokes.forEach((line, index) => {

        // Distribución continua por el anillo.
        const angle =
          (index / count) * Math.PI * 2;

        // Un tramo tangente del círculo
        // para cada línea del relleno.
        const targetCenterX =
          circle.x + Math.cos(angle) * circle.radius;

        const targetCenterY =
          circle.y + Math.sin(angle) * circle.radius;

        const tangentX = -Math.sin(angle);
        const tangentY = Math.cos(angle);

        const originalLength =
          line.x2 - line.x1;

        // Los trazos largos se compactan
        // conforme forman el organismo.
        const finalLength = clamp(
          originalLength * 0.20,
          2.2,
          11
        );

        const targetAx =
          targetCenterX - tangentX * finalLength / 2;

        const targetAy =
          targetCenterY - tangentY * finalLength / 2;

        const targetBx =
          targetCenterX + tangentX * finalLength / 2;

        const targetBy =
          targetCenterY + tangentY * finalLength / 2;

        const ax = lerp(line.x1, targetAx, t);
        const ay = lerp(line.y, targetAy, t);

        const bx = lerp(line.x2, targetBx, t);
        const by = lerp(line.y, targetBy, t);

        // Curvatura orgánica que solo actúa
        // durante la transformación.
        const bend =
          Math.sin(Math.PI * t) *
          Math.sin(index * 0.41 + now * 0.0012) *
          C.bend;

        const mx = (ax + bx) / 2;
        const my = (ay + by) / 2;

        const dx = bx - ax;
        const dy = by - ay;

        const length =
          Math.hypot(dx, dy) || 1;

        const normalX = -dy / length;
        const normalY = dx / length;

        const controlX = mx + normalX * bend;
        const controlY = my + normalY * bend;

        ctx.beginPath();
        ctx.moveTo(ax, ay);

        ctx.quadraticCurveTo(
          controlX,
          controlY,
          bx,
          by
        );

        ctx.stroke();
      });

      ctx.restore();
    }

    // ======================================
    // TRANSFERIR AL CÍRCULO ORIGINAL
    // ======================================

    function finish() {
      if (finished) return;
      finished = true;

      if (raf !== null) {
        cancelAnimationFrame(raf);
        raf = null;
      }

      intro.style.setProperty(
        "display", "none", "important"
      );

      showRealCircle();

      layer.remove();

      console.log(
        "UXS Intro Morph V4 Complete"
      );
    }

    // ======================================
    // ANIMACIÓN
    // ======================================

    function animate(now) {
      if (startedAt === null) {
        startedAt = now;
      }

      const elapsed = now - startedAt;

      ctx.clearRect(
        0, 0, width, height
      );

      // ==================================
      // FASE 1: TEXTO SÓLIDO
      // ==================================

      if (elapsed <= C.solidUntil) {
        ctx.save();

        ctx.globalAlpha = ease(
          elapsed / 550
        );

        drawSolid();

        ctx.restore();
      }

      // ==================================
      // FASE 2: EL RELLENO SE ESTIRA
      // ==================================

      else {
        const progress = clamp(
          (elapsed - C.solidUntil) /
          (C.morphEnd - C.solidUntil),
          0,
          1
        );

        // El texto permanece visualmente
        // lleno al comienzo del morph.
        //
        // Las líneas que lo forman van
        // tomando el relevo directamente.

        if (progress < 0.12) {
          ctx.save();

          ctx.globalAlpha =
            1 - ease(progress / 0.12);

          drawSolid();

          ctx.restore();
        }

        ctx.save();

        // Las líneas se mantienen visibles
        // mientras se deforman.
        ctx.globalAlpha = 1;

        drawLivingStrokes(progress, now);

        ctx.restore();
      }

      // ==================================
      // AVISO DE VOLUMEN
      // ==================================

      const hintIn = ease(
        (elapsed - 350) / 450
      );

      const hintOut =
        1 - ease(
          (elapsed - 1800) / 500
        );

      hint.style.opacity = String(
        0.4 * hintIn * hintOut
      );

      // ==================================
      // RELEVO DEL CÍRCULO
      // ==================================

      if (elapsed >= C.morphEnd) {
        showRealCircle();

        // El círculo original ya está
        // funcionando debajo de esta capa.
        const fade = ease(
          (elapsed - C.morphEnd) /
          (C.total - C.morphEnd)
        );

        layer.style.opacity =
          String(1 - fade);
      }

      if (elapsed >= C.total) {
        finish();
        return;
      }

      raf = requestAnimationFrame(animate);
    }

    // ======================================
    // INICIALIZAR
    // ======================================

    const reducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    if (reducedMotion) {
      finish();
      return;
    }

    prepare();

    window.addEventListener("resize", () => {
      if (!finished) {
        prepare();
      }
    });

    raf = requestAnimationFrame(animate);

    console.log(
      "UXS Intro Morph V4 Ready"
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initialize
    );
  } else {
    initialize();
  }
})();
